// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"25":"816c2a6a86107ccc","85":"1179683e976335c8","106":"dc00efd92eb17dfe","239":"47388d49805a8fb1","336":"6cd826ba57847314","347":"6aa306d7f8c505a3","464":"97a81d20a2dff6a0","916":"4e0e503d8117f6c6","941":"3c1c887fabaaf28e"}[chunkId] + ".js";
};